import {
  AdaptProps,
  SheetProps,
  Popover as TamaguiPopover,
  PopoverContentProps as TamaguiPopoverContentProps,
  PopoverProps as TamaguiPopoverProps,
} from 'tamagui'
import { ReactNode } from 'react'
import { shadowStandard } from '../../styles'

export type PopoverProps = TamaguiPopoverProps & {
  trigger?: ReactNode
  anchor?: ReactNode
  hideArrow?: boolean
  contentProps?: TamaguiPopoverContentProps
  isBouncy?: boolean
  sheetProps?: SheetProps
  adaptProps?: AdaptProps
}

export function Popover({
  trigger,
  anchor,
  children,
  hideArrow,
  contentProps,
  isBouncy = true,
  sheetProps,
  adaptProps,
  ...popoverProps
}: PopoverProps) {
  return (
    <TamaguiPopover size="$5" {...popoverProps}>
      {trigger && <TamaguiPopover.Trigger asChild>{trigger}</TamaguiPopover.Trigger>}
      {anchor && <TamaguiPopover.Anchor asChild>{anchor}</TamaguiPopover.Anchor>}
      <TamaguiPopover.Adapt when={'sm'} {...adaptProps}>
        <TamaguiPopover.Sheet modal dismissOnSnapToBottom snapPoints={[85, 50, 25]} {...sheetProps}>
          <TamaguiPopover.Sheet.Overlay bg="$backdrop" />
          <TamaguiPopover.Sheet.Handle bg="$white" opacity={0.9} />
          <TamaguiPopover.Sheet.Frame flexGrow={1} padding="$3.5" borderRadius={0}>
            <TamaguiPopover.Sheet.ScrollView minHeight="100%" h="100%" flexGrow={1}>
              {children}
            </TamaguiPopover.Sheet.ScrollView>
          </TamaguiPopover.Sheet.Frame>
        </TamaguiPopover.Sheet>
      </TamaguiPopover.Adapt>

      <TamaguiPopover.Content
        borderWidth={1}
        borderColor="$grey3"
        bg="$white"
        mx="$3.5"
        {...(isBouncy && {
          enterStyle: { x: 0, y: -10, opacity: 0 },
          exitStyle: { x: 0, y: -10, opacity: 0, pointerEvents: 'none' },
          x: 0,
          y: 0,
          o: 1,
          animation: [
            'quick',
            {
              opacity: {
                overshootClamping: true,
              },
            },
          ],
        })}
        padding={contentProps?.padding || 0}
        {...shadowStandard}
        {...contentProps}
      >
        {!hideArrow && <TamaguiPopover.Arrow borderWidth={1} borderColor="$grey3" />}
        {children}
      </TamaguiPopover.Content>
    </TamaguiPopover>
  )
}
